import Swal from "sweetalert2";

export const AlertSave = (callback: () => void) => {
  Swal.fire({
    title: "You might have unsaved changes!",
    text: "Will you discard these changes?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#2e7d32",
    cancelButtonColor: "#af3f3b",
    confirmButtonText: "Yes, discard changes!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback();
    }
  });
};
